import ContactSupport from "../components/ContactSupport";
import StudioAppsPage from "../components/StudioAppsPage";
import StudioFeaturesPage from "../components/StudioFeaturesPage";
import GlobalFunctions from "./GlobalFunctions";
import UndoManager from "./UndoManager";

export default class AllPagesUtil {
  public static load(): void {
    GlobalFunctions.ContactSupport = ContactSupport;

    GlobalFunctions.StudioAppsPage = StudioAppsPage;

    GlobalFunctions.StudioFeaturesPage = StudioFeaturesPage;

    UndoManager.load();
  }
}
